import { Avatar } from '@material-ui/core';
import { LenderName } from '@nemuru-eng/js-api-client';

import { useCustomTheme } from '@/hooks/useCustomTheme';

interface LenderIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  lenderName: LenderName;
  size?: number;
  isActive?: boolean;
  altColor?: boolean;
}

export const LenderIcon = ({ lenderName, size = 22, isActive = true, altColor = false, ...props }: LenderIconProps) => {
  const isIdleStyles = {
    filter: altColor ? 'brightness(0) invert(1)' : 'grayscale(1) contrast(0)',
    opacity: altColor ? 0.5 : 0.4,
  };

  return (
    <img
      src={`https://cdn.nemuru.com/assets/logos/letterform/${lenderName}-logo.svg`}
      alt={lenderName}
      {...props}
      style={{ ...props.style, width: `${size}px`, height: 'auto', ...(isActive ? {} : isIdleStyles) }}
    />
  );
};

interface LenderIconAvatar {
  lenderName: LenderName;
  size?: 'small' | 'medium';
  transparent?: boolean;
}

export const LenderIconAvatar = ({ lenderName, size = 'medium', transparent = false }: LenderIconAvatar) => {
  const { palette } = useCustomTheme();
  return (
    <Avatar
      style={{
        width: size === 'medium' ? 40 : 24,
        height: size === 'medium' ? 40 : 24,
        background: transparent ? 'transparent' : palette.grey[50],
      }}
    >
      <LenderIcon
        lenderName={lenderName}
        style={{
          width: size === 'medium' ? 36 : 16,
          maxHeight: size === 'medium' ? 36 : 16,
        }}
      />
    </Avatar>
  );
};
